






















































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { app } from "../../models/Application";
import { Order, OrderStatus, OrderDetail } from "../../viewmodels/Order";
import { CategoryType } from "../../viewmodels/Category";

@Component({})
export default class extends Vue {
  public collection = app.orderCollection;

  public search: string = "";
  public model: Order = new Order({}, this.collection);

  public dialog = false;
  public formTitle: string = "Restaurant";

  public headers = [
    { text: "Id", value: "id" },
    { text: "Customer", value: "customer_name" },
    { text: "Phone", value: "customer_phone" },
    { text: "Address", value: "address" },
    { text: "Total", value: "total" },
    { text: "Actions", value: "" }
  ];

  public mounted() {
    this.search = this.collection.search;
    this.collection.refreshData();
  }

  @Watch("search")
  public onSearchChange() {
    this.collection.doSearch(this.search);
  }

  public close() {
    this.dialog = false;
  }

  public filterOnlyOrdersWithDelivery(items: Order[]) {
    const user = app.loginService.currentUser();
    return items.filter(
      order =>
        order.status === OrderStatus.ReadyForDelivery &&
        order.delivery === true &&
        order.driver_id === user.id
    );
  }

  public async markAsOutToDelivery(item: Order) {
    this.model = item;
    try {
      const dialog: any = (this.$root as any).$confirm;
      dialog(
        "Order Status Change",
        "This order's status will be changed?"
      ).then(async (confirm: boolean) => {
        if (confirm) {
          await this.model.changeOrderStatus(OrderStatus.Delivered);
          app.refreshData();
          this.dialog = false;
          this.$store.dispatch("showSnackbar", {
            message: "Order status changed to 'out to delivery' succesfully!"
          });
        }
      });
    } catch (e) {
      this.$store.dispatch("showSnackbar", {
        message: "Whoops, error while saving data!"
      });
    }
  }
}
